import api from '@/libs/axiosInstance';
import type { BrandDiscoveryPreferences } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const discoveryPreferencesQueryKey = (brandId: string) =>
  ['discoveryPreferences', brandId] as const;

interface DiscoveryPreferencesResponse {
  preferences: BrandDiscoveryPreferences | null;
  updatedAt: string | null;
}

const fetchDiscoveryPreferences = async (): Promise<BrandDiscoveryPreferences | null> => {
  const { data } = await api.get<{ data: DiscoveryPreferencesResponse }>(
    '/dashboard/brands/me/discovery-preferences'
  );
  return data.data.preferences;
};

export const useDiscoveryPreferencesQuery = (brandId: string) => {
  return useQuery<BrandDiscoveryPreferences | null, Error>({
    queryKey: discoveryPreferencesQueryKey(brandId),
    queryFn: fetchDiscoveryPreferences,
    enabled: !!brandId,
    // Prefs only change via explicit extract/save, which use setQueryData to update the cache.
    staleTime: Infinity,
  });
};
